import {State, Action, StateContext, Selector} from '@ngxs/store';
import { RoleModel } from '../models/role.model';
import { CreateRole,GetRoles, SetSelectedRole } from '../actions/roleManagement.action';
import {tap} from 'rxjs/operators';
import { RoleBasedService } from '../services/role-based.service';

export class RoleStateModel{
    roles: RoleModel[];
    selectedRole: RoleModel;
}

@State<RoleStateModel>({
    name: 'roles',
    defaults: {
        roles: [],
        selectedRole: null
    }
})


export class RoleState{

    constructor(private roleBasedService: RoleBasedService){
    }

    @Selector()
    static getRoleList(state: RoleStateModel) {
        return state.roles;
    }
    @Selector()
    static getSelectedRole(state: RoleStateModel) {
        return state.selectedRole;
    }

    @Action(CreateRole)
    createRole({getState, patchState}: StateContext<RoleStateModel>, {payload}: CreateRole) {
        return this.roleBasedService.createRole(payload).pipe(tap((result) => {
            const state = getState();
            patchState({
                roles: [...state.roles, result]
            });
        }));
    }

    @Action(GetRoles)
    getRoles({getState, setState}: StateContext<RoleStateModel>) {
        return this.roleBasedService.getRoles().pipe(tap((result) => {
            const state = getState();
          
            setState({
               ...state,
                
               // roles: result,
            });
        }));
    }

    // @Action(DeleteRoles)
    // deleteRoles({getState, setState}: StateContext<RoleStateModel>, {id}: DeleteRoles) {
    //     return this.roleBasedService.deleteRoles(id).pipe(tap(() => {
    //         const state = getState();
    //         const filteredArray = state.roles.filter(item => item.roleId !== id);
    //         setState({
    //             ...state,
    //             roles: filteredArray,
    //         });
    //     }));
    // }

    // @Action(UpdateRoles)
    // updateRoles({getState, setState}: StateContext<RoleStateModel>, {payload, id}: UpdateRoles) {
    //     return this.roleBasedService.updateRoles(payload, id).pipe(tap((result) => {
    //         const state = getState();
    //         const getRoleList = [...state.roles];
    //         const getRoleIndex = getRoleList.findIndex(item => item.roleId === id);
    //         getRoleList[getRoleIndex] = result;
    //         setState({
    //             ...state,
    //             roles: getRoleList,
    //         });
    //     }));
    // }

    @Action(SetSelectedRole)
    setSelectedRoleId({getState, setState}: StateContext<RoleStateModel>, {payload}: SetSelectedRole) {
        const state = getState();
        setState({
            ...state,
            selectedRole: payload
        });
    }


}